import type { ComponentProps } from 'react';

import type { Profile } from 'src/App/AppPageBlock/ProfileDrawer/DetailsContentView/Profile/service/types';
import type RoleRequirement from 'src/components/list/JobApplicationCard/RoleRequirementsView/RoleRequirement';
import { STATUS_CERTIFIED } from 'src/constants/roleRequirementStatus.ts';

/**
 * Determine whether Verified credentials badge should be shown for a candidate.
 * If there's any SEEK Pass supertick on the application card or profile, the badge should be shown.
 */
export const hasVerifiedCredentials = ({
  roleRequirements,
  profile,
}: {
  roleRequirements: Array<
    ComponentProps<typeof RoleRequirement>['roleRequirement']
  >;
  profile: Profile | null;
}) => {
  if (profile?.verifiedIdentity?.fullName) {
    return true;
  }

  if (
    roleRequirements.some(
      (rr) => rr.status === STATUS_CERTIFIED || rr.showVerifiedTagInAnswers,
    )
  ) {
    return true;
  }

  if (
    profile?.qualifications.some((q) => q.isVerified || Boolean(q.credential))
  ) {
    return true;
  }

  if (profile?.licences.some((l) => l.isVerified || Boolean(l.credential))) {
    return true;
  }

  return false;
};
